import { render, staticRenderFns } from "./StripBanner.vue?vue&type=template&id=bbd0c3e8"
import script from "./StripBanner.vue?vue&type=script&lang=js"
export * from "./StripBanner.vue?vue&type=script&lang=js"
import style0 from "./StripBanner.vue?vue&type=style&index=0&id=bbd0c3e8&prod&lang=postcss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports